// extracted by mini-css-extract-plugin
export default {"projectRow":"ProjectsList-module__projectRow--6b56","title":"ProjectsList-module__title--914a","btnAdded":"ProjectsList-module__btnAdded--ecb5"};